<template>
  <div class="form-group" :class="{ 'is-invalid': hasErrorsBoth }">
    <slot
      :errors="activeErrors"
      :events="events"
      :first-error-message="activeErrorMessagesBoth"
      :has-errors="hasErrorsBoth"
      :validator="preferredValidator"
    />
  </div>
</template>

<script>
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
import ServerSideValidation from "@/mixins/ServerSideValidation";
import get from "lodash/get";

const _ = { get };

export default {
  name: "FormGroup",
  mixins: [singleErrorExtractorMixin, ServerSideValidation],
  props: {
    cols: {
      type: String,
      default: "col-md-offset-4 col-md-8 col-xs-12"
    }
  }
};
</script>
